import { makeWriteContractAsync } from '@/utils/wagmi/makeOperations'
import { useSurveyFactoryContractAddress } from './useSurveyFactoryContract'
import { abi as factoryAbi } from '@/abi/SurveyFactory'
import { wagmiConfig } from '@/config/wagmi-config'
import { useMemo } from 'react'

export function useWriteFactoryContract() {
	const factoryAddress = useSurveyFactoryContractAddress()

	return useMemo(
		() => makeWriteContractAsync(wagmiConfig, { abi: factoryAbi, address: factoryAddress }),
		[factoryAddress]
	)
}
